/**
 * Long-form copy for /services/athletes — one array per locale.
 * To add a language: add a key here and register the locale in src/i18n/locales/index.js.
 */
export const athleteServiceItemsByLocale = {
  de: [
    {
      title: "1. Rechtliche Beratung",
      text: "Rechtliche Beratung mit assoziierten internationalen und nationalen Kanzleien in den für die Athletenbetreuung und die Sportökonomie bedeutsamen Feldern Vertragsrecht, Versicherungsrecht, Medienrecht, Markenrecht/Markenanmeldung, Gesellschaftsrecht, Gewerberecht und Lizenzrecht",
    },
    {
      title: "2. Steuerrechtliche Beratung",
      text: "Steuerrechtliche Beratung mit assoziierten und auf Athletenbetreuung spezialisierten Steuerberatern, Fachanwälten für Steuerrecht und Wirtschaftsprüfern",
    },
    {
      title: "3. Versicherungsrechtliche Beratung",
      text: "Versicherungsrechtliche Beratung mit Fachanwälten für Versicherungsrecht und unabhängigen Versicherungsmaklern",
    },
    {
      title: "4. Vermarktung/Sponsorenakquisition",
      text: "Vermarktung aller vermarktungsfähigen Rechte der Athletinnen und Athleten (Werbeflächensponsoring, TV-Spots, Print- und Plakatkampagnen, Internet, PR, Social Media, Ausrüsterverträge, Beraterverträge) einschließlich Vertragsverhandlungen und Vertragsabschlüssen",
    },
    {
      title: "5. Vermarktungsunterstützende Marktforschung",
      text: "TV-Spot-Monitoring und TV-Spot-Screening, Kampagnen-Audits bei Unternehmen, Affinitäts-Analysen Sportart/Sportler-Unternehmen/Produkt",
    },
    {
      title: "6. Sportökonomische Marktforschung",
      text: "Quantitative und qualitative Marktforschung für Athletinnen und Athleten, Bekanntheitsgrad und Beliebtheitswerte, „label-on-screen“-Messungen, Werbeäquivalenzwerte, Sponsoringcontrolling, Balance-Scorecard für Sponsoringprojekte",
    },
    {
      title: "7. Sportwissenschaftliches und sportmedizinisches Netzwerk",
      text: "Sportwissenschaftliches und sportmedizinisches Netzwerk mit Stützpunkten (Universitäre Lehrstühle, Kliniken, Ärzte) in den Bereichen Innere Medizin, Chirurgie, Augenheilkunde, Ernährungswissenschaften, Sportpsychologie, Orthopädie, komplementäre Sportmedizin wie z.B. Kinesiologie, Manualtherapie und Maßnahmen komplexer Regeneration",
    },
    { title: "8. Strategische Presse- und Öffentlichkeitsarbeit", text: "Positionierung, Imageaufbau" },
    {
      title: "9. Operative Presse- und Öffentlichkeitsarbeit",
      text: "Operative Presse – und Öffentlichkeitsarbeit für Athletinnen und Athleten (Reportagen/Interviews/Kolumnen/Medienprojekte, Pressebetreuung, Pressedienste) sowie für deren Sponsoren und Sponsorenprojekte mit einem aus rund 700 Print- und online Redaktionen bestehenden nationalen und internationalen PR-Netzwerk",
    },
    { title: "10. Medienberatung", text: "Interviewtraining, Webdesign, Social Media-Beratung" },
    { title: "11. Publikation von Sportbiografien", text: "Autorenschaft, Lektorat Verlag, Druck, Vertrieb" },
    {
      title: "12. Merchandising",
      text: "Entwicklung von Merchandisingkonzepten (Produkt, Preis, Vertrieb, Kommunikation) für Athleten, Implementierung von online-shops bei Athletenhomepages",
    },
    {
      title: "13. Finanzlogistik",
      text: "Gewerbeanmeldung- und beratung, Rechnungswesen und Fakturierungen, Fälligkeiten- und Fristenkontrollen, Buchhaltung",
    },
    { title: "14. Autogrammkartenservice", text: "Design, Druck, Versendung/Fanservice" },
    {
      title: "15. Schulische und Studentenbetreuung",
      text: "Schulische und Studiumbetreuung in den Fächern BWL, VWL, Rechtswissenschaften, Sportökonomie (fachspezifische Unterstützung, Abiturvorbereitungen, Beratung zu Bachelor- und Masterarbeiten)",
    },
    {
      title: "16. Persönlichkeitsentwicklung",
      text: 'Potenzialanalysen, wissenschaftliche Tests zu Persönlichkeitsmerkmalen, "Life Culture"',
    },
    {
      title: "17. Allgemeine Organisation/Beratung",
      text: "Übernahme allgemeiner Planungen und Maßnahmen zu wirtschaftlichen/beruflichen Fragestellungen",
    },
    { title: "18. Nachkarriereberatung", text: "Berufs- und Studienberatung, Personalberatung, Stellenvermittlung" },
  ],
  en: [
    {
      title: "1. Legal consulting",
      text: "Legal consulting with associated international and national law firms in the fields that matter for athlete management and sports economics: contract law, insurance law, media law, trademark law and trademark applications, corporate law, commercial law, and licensing law",
    },
    {
      title: "2. Tax law consulting",
      text: "Tax law consulting with associated tax advisors specialized in athlete management, specialist attorneys for tax law, and certified public accountants",
    },
    {
      title: "3. Insurance law consulting",
      text: "Insurance law consulting with specialist attorneys for insurance law and independent insurance brokers",
    },
    {
      title: "4. Marketing / sponsor acquisition",
      text: "Marketing of all marketable rights of athletes (advertising-space sponsorship, TV spots, print and poster campaigns, internet, PR, social media, equipment agreements, advisory agreements), including contract negotiations and conclusion of contracts",
    },
    {
      title: "5. Market research supporting marketing",
      text: "TV spot monitoring and TV spot screening, campaign audits with companies, affinity analyses sport/athlete–company/product",
    },
    {
      title: "6. Sports economics market research",
      text: "Quantitative and qualitative market research for athletes, awareness and popularity metrics, “label-on-screen” measurements, advertising equivalence values, sponsorship controlling, balanced scorecard for sponsorship projects",
    },
    {
      title: "7. Sports science and sports medicine network",
      text: "A sports science and sports medicine network with hubs (university chairs, clinics, physicians) in internal medicine, surgery, ophthalmology, nutritional sciences, sports psychology, orthopedics, complementary sports medicine such as kinesiology and manual therapy, and measures for complex recovery",
    },
    { title: "8. Strategic press and public relations", text: "Positioning, image building" },
    {
      title: "9. Operational press and public relations",
      text: "Operational press and public relations for athletes (features/interviews/columns/media projects, press relations, press services) as well as for their sponsors and sponsorship projects, with a national and international PR network of around 700 print and online editorial offices",
    },
    { title: "10. Media consulting", text: "Interview training, web design, social media consulting" },
    { title: "11. Publication of sports biographies", text: "Authorship, publishing editorial services, printing, distribution" },
    {
      title: "12. Merchandising",
      text: "Development of merchandising concepts (product, price, distribution, communication) for athletes; implementation of online shops on athlete websites",
    },
    {
      title: "13. Financial logistics",
      text: "Business registration and advice, accounting and invoicing, due-date and deadline monitoring, bookkeeping",
    },
    { title: "14. Autograph card service", text: "Design, printing, dispatch / fan service" },
    {
      title: "15. School and university support",
      text: "School and degree-program support in business administration, economics, law, and sports economics (subject-specific support, Abitur preparation, guidance on bachelor’s and master’s theses)",
    },
    {
      title: "16. Personal development",
      text: 'Potential analyses, scientific tests on personality traits, "Life Culture"',
    },
    {
      title: "17. General organization / consulting",
      text: "General planning and measures relating to economic and professional issues",
    },
    { title: "18. Post-career consulting", text: "Career and study counseling, executive search / HR consulting, job placement" },
  ],
  fr: [
    {
      title: "1. Conseil juridique",
      text: "Conseil juridique avec des cabinets associés internationaux et nationaux dans les domaines déterminants pour l’accompagnement des athlètes et l’économie du sport : droit des contrats, droit des assurances, droit des médias, droit des marques / dépôt de marque, droit des sociétés, droit commercial et droit des licences",
    },
    {
      title: "2. Conseil en droit fiscal",
      text: "Conseil en droit fiscal avec des conseillers fiscaux associés spécialisés dans l’accompagnement des athlètes, des avocats spécialisés en droit fiscal et des experts-comptables",
    },
    {
      title: "3. Conseil en droit des assurances",
      text: "Conseil en droit des assurances avec des avocats spécialisés en droit des assurances et des courtiers d’assurance indépendants",
    },
    {
      title: "4. Marketing / acquisition de sponsors",
      text: "Commercialisation de tous les droits exploitables des athlètes (sponsoring d’espaces publicitaires, spots TV, campagnes print et affichage, internet, RP, réseaux sociaux, contrats d’équipement, contrats de conseil), y compris négociation et conclusion des contrats",
    },
    {
      title: "5. Études de marché au service du marketing",
      text: "Suivi et sélection de spots TV, audits de campagnes en entreprise, analyses d’affinité sport / athlète – entreprise / produit",
    },
    {
      title: "6. Études de marché en économie du sport",
      text: "Études de marché quantitatives et qualitatives pour les athlètes, notoriété et popularité, mesures « label-on-screen », équivalence publicitaire, controlling du sponsoring, balanced scorecard pour projets de sponsoring",
    },
    {
      title: "7. Réseau sciences du sport et médecine du sport",
      text: "Réseau de sciences du sport et de médecine du sport avec des relais (chaires universitaires, cliniques, médecins) en médecine interne, chirurgie, ophtalmologie, sciences de la nutrition, psychologie du sport, orthopédie, médecine du sport complémentaire comme la kinésiologie, la thérapie manuelle et mesures de récupération complexe",
    },
    { title: "8. Relations presse et publiques stratégiques", text: "Positionnement, construction d’image" },
    {
      title: "9. Relations presse et publiques opérationnelles",
      text: "Relations presse et publiques opérationnelles pour les athlètes (reportages, interviews, chroniques, projets médias, accompagnement presse, services de presse) ainsi que pour leurs sponsors et projets de sponsoring, avec un réseau RP national et international d’environ 700 rédactions print et en ligne",
    },
    { title: "10. Conseil médias", text: "Formation aux interviews, conception web, conseil réseaux sociaux" },
    { title: "11. Publication de biographies sportives", text: "Rédaction, relecture éditoriale, impression, distribution" },
    {
      title: "12. Merchandising",
      text: "Élaboration de concepts de merchandising (produit, prix, distribution, communication) pour athlètes ; mise en place de boutiques en ligne sur les sites des athlètes",
    },
    {
      title: "13. Logistique financière",
      text: "Immatriculation d’activité et conseil, comptabilité et facturation, suivi des échéances et délais, tenue des livres",
    },
    { title: "14. Service de cartes dédicacées", text: "Design, impression, envoi / service fans" },
    {
      title: "15. Accompagnement scolaire et universitaire",
      text: "Accompagnement scolaire et des études en gestion, économie, droit et économie du sport (soutien disciplinaire, préparation au baccalauréat allemand, conseil pour mémoires de licence et master)",
    },
    {
      title: "16. Développement personnel",
      text: "Analyses de potentiel, tests scientifiques sur les traits de personnalité, « Life Culture »",
    },
    {
      title: "17. Organisation générale / conseil",
      text: "Prise en charge de planifications et mesures générales relatives aux questions économiques et professionnelles",
    },
    {
      title: "18. Conseil après-carrière",
      text: "Conseil professionnel et d’études, conseil en ressources humaines, placement",
    },
  ],
  es: [
    {
      title: "1. Asesoramiento jurídico",
      text: "Asesoramiento jurídico con bufetes asociados internacionales y nacionales en los ámbitos relevantes para el acompañamiento de deportistas y la economía del deporte: derecho contractual, de seguros, de medios, de marcas y registro de marcas, societario, mercantil y de licencias",
    },
    {
      title: "2. Asesoramiento fiscal",
      text: "Asesoramiento fiscal con asesores fiscales asociados especializados en deportistas, abogados especialistas en derecho fiscal y auditores",
    },
    {
      title: "3. Asesoramiento en derecho de seguros",
      text: "Asesoramiento en derecho de seguros con abogados especialistas en seguros y corredores de seguros independientes",
    },
    {
      title: "4. Marketing / adquisición de patrocinadores",
      text: "Comercialización de todos los derechos explotables de los deportistas (patrocinio de espacios publicitarios, spots de TV, campañas en prensa y carteles, internet, RR.PP., redes sociales, contratos de equipación, contratos de asesoramiento), incluidas negociación y cierre de contratos",
    },
    {
      title: "5. Investigación de mercado para el marketing",
      text: "Monitorización y selección de spots TV, auditorías de campañas en empresas, análisis de afinidad deporte / deportista – empresa / producto",
    },
    {
      title: "6. Investigación de mercado en economía del deporte",
      text: "Investigación de mercado cuantitativa y cualitativa para deportistas, notoriedad y popularidad, mediciones «label-on-screen», equivalencia publicitaria, control del patrocinio, cuadro de mando para proyectos de patrocinio",
    },
    {
      title: "7. Red de ciencias del deporte y medicina deportiva",
      text: "Red de ciencias del deporte y medicina deportiva con nodos (cátedras universitarias, clínicas, médicos) en medicina interna, cirugía, oftalmología, ciencias de la nutrición, psicología del deporte, ortopedia, medicina deportiva complementaria como kinesiología, terapia manual y medidas de recuperación compleja",
    },
    { title: "8. Relaciones públicas y con la prensa estratégicas", text: "Posicionamiento, construcción de imagen" },
    {
      title: "9. Relaciones públicas y con la prensa operativas",
      text: "Relaciones públicas y con la prensa operativas para deportistas (reportajes, entrevistas, columnas, proyectos mediáticos, atención a medios, servicios de prensa) así como para sus patrocinadores y proyectos de patrocinio, con una red nacional e internacional de RR.PP. de unas 700 redacciones en prensa y online",
    },
    { title: "10. Asesoramiento mediático", text: "Formación para entrevistas, diseño web, asesoramiento en redes sociales" },
    { title: "11. Publicación de biografías deportivas", text: "Autoría, edición editorial, impresión, distribución" },
    {
      title: "12. Merchandising",
      text: "Desarrollo de conceptos de merchandising (producto, precio, distribución, comunicación) para deportistas; implementación de tiendas online en webs de deportistas",
    },
    {
      title: "13. Logística financiera",
      text: "Alta de actividad económica y asesoramiento, contabilidad y facturación, control de vencimientos y plazos, teneduría de libros",
    },
    { title: "14. Servicio de tarjetas autógrafas", text: "Diseño, impresión, envío / atención a fans" },
    {
      title: "15. Acompañamiento escolar y universitario",
      text: "Acompañamiento escolar y de estudios en administración de empresas, economía, derecho y economía del deporte (apoyo específico, preparación Abitur, asesoramiento para tesis de grado y máster)",
    },
    {
      title: "16. Desarrollo personal",
      text: "Análisis de potencial, pruebas científicas sobre rasgos de personalidad, «Life Culture»",
    },
    {
      title: "17. Organización general / asesoramiento",
      text: "Asunción de planificaciones y medidas generales en cuestiones económicas y profesionales",
    },
    {
      title: "18. Asesoramiento post-carrera",
      text: "Asesoramiento profesional y académico, consultoría de personal, colocación laboral",
    },
  ],
};

export function getAthleteServiceItems(locale) {
  const items = athleteServiceItemsByLocale[locale];
  if (items) return items;
  return athleteServiceItemsByLocale.en;
}
